import "./Footer.css";

export default function Footer() {
    return <div className="Footer-Style">
        Coded by <a href="https://github.com/siv921" target="_blank" rel="noreferrer">Anastasia Sivets</a> open-sourced on <a href="https://github.com/siv921/new-react-dictionary-app.git"  rel="noreferrer" target="_blank">Git Hub </a>
           </div>;
}